//import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    getCleaningtasks, getCleaningtypes, getView
} from "../dbconnector/connector";
import { setErrorMessage, setMessage } from "../tools/errorhandling";
import EmployeeRoosterNode from '../customNodes/EmployeeRoosterNode';
import Button from 'react-bootstrap/Button';
import { confirmAlert } from 'react-confirm-alert';
import { use } from 'react';
import { useMemo } from 'react';
import moment from 'moment';
import logo from "../invoices/logo.png"
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import React, { Component, PropTypes } from 'react';
import { TbSend2 } from 'react-icons/tb';
import { BsFillSave2Fill } from 'react-icons/bs';

const DagstaatNode = ({ rights, hotel, hotelid, t, datum }) => {

    const [generalservicestasksarray, setgeneralservicestasksarray] = useState([]);
    const [generalservicesextratimearray, setgeneralservicesextratimearray] = useState([]);
    const [payedtasksarray, setpayedtasksarray] = useState([]);
    const [generalservicestasks, setgeneralservicestasks] = useState([]);
    const [generalservicespayedtasksarray, setgeneralservicespayedtasksarray] = useState([]);
    const [cleaningtypearray, setcleaningtypearray] = useState([]);
    const [cleaningtypearrayAD, setcleaningtypearrayAD] = useState([]);
    const [CleaningTypes, setCleaningTypes] = useState({});
    const [dagstaten, setDagstaten] = useState([]);
    const [dagstaten_payedtasks, setDagstaten_payedtasks] = useState([]);
    const [dagstaten_comments, setDagstaten_comments] = useState([]);
    const [dagstaten_commentsarray, setDagstaten_commentsarray] = useState([]);


    useEffect(() => {

        GetDagStaten();
        GetDagStaten_payedtasks();
        Getgeneralservicestasks();
        Get_comments_assignments();
        //Getcleaningtypes()
    }, [hotelid]);

    useEffect(() => {
        if (generalservicestasks.length > 0) {
            const types = generalservicestasks
            const array = []
            setpayedtasksarray([]);
            setgeneralservicespayedtasksarray([]);
            setgeneralservicestasksarray([]);
            setgeneralservicesextratimearray([]);
            types.forEach((item, index) => {
                //console.log("type", item)
                let aantal = 0
                if (dagstaten_payedtasks.length > 0) {
                    dagstaten_payedtasks.forEach((taak, index) => {
                        if (taak.cleaningtype_Id !== -1) {
                            if (taak.multiple !== "{}") {
                                let multipletasks = JSON.parse(taak.multiple)
                                const filteredkeys = Object.keys(multipletasks)
                                filteredkeys.forEach((key) => {
                                    if (item.Id === Number(key)) {
                                        aantal = Number(multipletasks[key]) + aantal
                                    }
                                })
                            }
                            else if (taak.tasks !== "") {
                                if (item.Id === Number(taak.tasks)) {
                                    aantal = 1 + aantal
                                }
                            }
                        }
                    })
                }
                if (item.AD === 0) {
                    setpayedtasksarray(pre => [...pre,
                    <tr >
                        <td className="dagstaat_celborderL" width="225">{item.taskDescription}</td>
                        <td className="dagstaat_celborderR" width="425">{aantal}</td>
                    </tr>

                    ])
                }
                if (item.AD === 1) {
                    setgeneralservicespayedtasksarray(pre => [...pre,
                    <tr>
                        <td className="dagstaat_celborderL" width="225">{item.taskDescription}</td>
                        <td className="dagstaat_celborderR" width="425">{aantal}</td>
                    </tr>

                    ])
                }
            })
            let adaantal = 0
            let aduren = 0
            types.forEach((item, index) => {
                if (dagstaten_payedtasks.length > 0) {
                    dagstaten_payedtasks.forEach((taak, index) => {
                        if (taak.cleaningtype_Id === -1) {
                            if (taak.multiple !== "{}") {
                                let multipletasks = JSON.parse(taak.multiple)
                                const filteredkeys = Object.keys(multipletasks)
                                filteredkeys.forEach((key) => {
                                    if (item.Id === Number(key)) {
                                        adaantal = Number(multipletasks[key]) + adaantal
                                    }
                                })
                            }
                            else if (taak.tasks !== "") {
                                if (item.Id === Number(taak.tasks)) {
                                    adaantal = 1 + adaantal
                                }
                            }
                            if (taak.extratime > 0) {
                                aduren = aduren + taak.extratime
                            }
                        }
                    })
                }
            })
            setgeneralservicestasksarray(pre => [...pre,
            <tr >
                <td className="dagstaat_celborderL">Algemene dienst - extra taken</td>
                <td className="dagstaat_celborderR">{adaantal}</td>
            </tr>
            ])

            setgeneralservicesextratimearray(pre => [...pre,
            <table cellspacing="0" cellpadding="0" class="dagstaat_subtable" width="650">
                <tr key="headertabled0" id="headertabled" >
                    <td className="dagstaat_celborderTopLine">&nbsp;</td>
                    <td className="dagstaat_celborderTopLine">Uren</td>
                </tr>

                <tr >
                    <td className="dagstaat_celborderL">Algemene dienst - uren</td>
                    <td className="dagstaat_celborderR">{aduren / 60}</td>
                </tr>
            </table>

            ])
        }
    }, [generalservicestasks, dagstaten_payedtasks]);

    useEffect(() => {
        setDagstaten_commentsarray([]);
        let comments = ""
        //console.log("dagstaten_comments: ", dagstaten_comments)
        if (dagstaten_comments.length > 0) {
            //console.log("dagstaten_comments: ", dagstaten_comments)
            const types = dagstaten_comments
            comments = "";
            types.forEach((item, index) => {
                comments = comments + " kamer " + item.roomnumber + " : " + item.description + "\n"
            })
            //console.log("comments", comments)
            if (comments !== "") {
                setDagstaten_commentsarray(pre => [...pre,
                <textarea className="dagstaat_textarea" border="1">
                    {comments}
                </textarea>
                ])
            } else {
                setDagstaten_commentsarray(pre => [...pre,
                <textarea className="dagstaat_textarea" border="1">
                    Geen opmerkingen
                </textarea>
                ])
            }
        } else {
            setDagstaten_commentsarray(pre => [...pre,
            <textarea className="dagstaat_textarea" border="1">
                Geen opmerkingen
            </textarea>
            ])
        }

    }, [dagstaten_comments]);

    useEffect(() => {
        let blijvers = 0;
        let vertrekkers = 0;
        let firstword = t('Aantal ')

        setcleaningtypearray([]);
        setcleaningtypearrayAD([]);
        //console.log("CleaningTypes length : ", CleaningTypes)
        // console.log("dagstaten length : ", dagstaten)
        if (dagstaten.length > 0) {
            dagstaten.forEach((item, index) => {
                blijvers = item.blijvers
                vertrekkers = item.vertrekkers
                // console.log("dagstaat : ", item)

                setcleaningtypearray(pre => [...pre,
                <tr id={"blijvers" + index}>
                    <td id={"blijvers_0" + index} width="225" className="dagstaat_celborderL">{t('Aantal')} {t('Blijvers')}</td>
                    <td id={"blijvers_1" + index} width="425" className="dagstaat_celborderR">{item.blijvers}</td>
                </tr>
                ])

                setcleaningtypearray(pre => [...pre,
                <tr id={"vertrekkers" + index}>
                    <td id={"Vertrekkers_0" + index} className="dagstaat_celborderL">{t('Aantal')} {t('Vertrekkers')}</td>
                    <td id={"Vertrekkers_1" + index} className="dagstaat_celborderR">{item.vertrekkers}</td>
                </tr>
                ])

                setcleaningtypearray(pre => [...pre,
                <tr id={"SpecialRequests" + index}>
                    <td id={"SpecialRequests_O" + index} className="dagstaat_celborderL">{t('Aantal')} {t('SpecialRequests')}</td>
                    <td id={"SpecialRequests_1" + index} className="dagstaat_celborderR">{item.specialrequests}</td>
                </tr>
                ])


                setcleaningtypearrayAD(pre => [...pre,
                // <table cellspacing="0" cellpadding="0" class="dagstaat_subtable ">

                <tr id={"algemenedienst" + index}>
                    <td id={"algemenedienst_0" + index} width="225" className="dagstaat_celborderL">{t('Aantal')} {t('Algemene dienst')}</td>
                    <td id={"algemenedienst_1" + index} width="425" className="dagstaat_celborderR">{item.algemenedienst}</td>
                </tr>
                    // </table>
                ])
            })
        }

    }, [dagstaten]);

    const GetDagStaten = async () => {
        if (hotel.Hotel_ID) {
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
            setDagstaten([])
            await getView("dagstaten", fields, values).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setDagstaten(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const GetDagStaten_payedtasks = async () => {
        if (hotel.Hotel_ID) {
            setDagstaten_payedtasks([])
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
            await getView("dagstaten_hotel_day_payedtasks", fields, values).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setDagstaten_payedtasks(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }

    const Getgeneralservicestasks = async () => {
        if (hotel.Hotel_ID) {
            await getCleaningtasks(hotel.Hotel_ID, 1).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setgeneralservicestasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const Getcleaningtypes = async () => {

        if (hotel.Hotel_ID) {
            await getCleaningtypes(hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTypes(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText, "failed to refresh cleaningtypes")
                }
            })
        }
    }

    const Get_comments_assignments = () => {
        if (hotel.Hotel_ID) {
            setDagstaten_comments([])
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
            //console.log("fields: ", fields)
            //console.log("values: ", values)
            getView("comments_assigments", fields, values).then(res => {
                if (res.status === 200) {

                    res.json().then(body => {
                        setDagstaten_comments(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const senddagstaat = () => {
        // const input = document.getElementById('roosterform');
        ////console.log(input)
        // html2canvas(input).then((canvas) => {
        //     const imgData = canvas.toDataURL('image/png');
        //     const pdf = new jsPDF();
        //     pdf.addImage(imgData, 'JPEG', 0, 0);
        //     // pdf.output('dataurlnewwindow');
        //     pdf.save("download.pdf");
        // })
        //console.log("height :", document.getElementById('printcanvas').clientHeight)
        //console.log("width :", document.getElementById('printcanvas').clientWidth)

        // htmlToImage.toPng(document.getElementById('printcanvas'), { quality: 1 })
        //     .then(function (dataUrl) {
        //         var link = document.createElement('a');
        //         link.download = 'my-image-name.jpeg';
        //         const pdf = new jsPDF("p", "mm", "a4");

        //         var width = pdf.internal.pageSize.getWidth();
        //         var height = pdf.internal.pageSize.getHeight();
        //         if (document.getElementById('printcanvas').clientHeight > 891) {
        //             width = 0
        //         }
        //         pdf.addImage(dataUrl, 'PNG', 0, 0, width, height);
        //         pdf.save("download.pdf");
        //     });
    }

    return (
        <>
            <form id="roosterform" >
                <div id="printcanvasll" className="printcanvas">
                <table cellspacing="0" cellpadding="0" border="0" width="700" id="printcanvas" className='dagstaat_table'>
                    <tr><td><img class="dagstaat_logo"  width="120" height="109" /></td><td class="dagstaat_title">{t('DAGSTAAT')}</td></tr>
                    <tr><td class="dagstaat_celborderL">{t('Naam Hotel')}</td><td class="dagstaat_celborderR">{hotel.Name}</td></tr>
                    <tr><td class="dagstaat_celborderL">{t('Datum')}</td><td class="dagstaat_celborderR">{moment(new Date(datum).toLocaleDateString('en-CA')).format("DD-MMM-YYYY")}</td></tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr><td colspan="2" class="border">
                        <label class="dagstaat_titleContentBox"><b>{t('Cleaningassignments')}</b></label>
                        <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">
                            {cleaningtypearray}
                            <tr>
                                <td colspan="2" className="dagstaat_celborderTopLine"><i>Extra betalende taken</i></td>
                            </tr>
                            {payedtasksarray}
                        </table>
                    </td></tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr><td colspan="2" class="border">
                        <label class="dagstaat_titleContentBox"><b>{t('Algemene dienst')}</b></label>
                        <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">
                            {cleaningtypearrayAD}
                            <tr>
                                <td colspan="2" class="dagstaat_celborderTopLine"><i>Extra betalende taken</i></td>
                            </tr>

                            {generalservicespayedtasksarray}
                        </table>
                        
                            {generalservicesextratimearray}
                        
                    </td></tr>
                    <tr><td colspan="2" className="dagstaat_celborderTopLine">Opmerkingen</td></tr>
                    <tr><td colspan="2">{dagstaten_commentsarray}</td></tr>
                    <tr><td colspan="2" className="dagstaat_celborderTopLine">Technische gebreken</td></tr>
                    <tr><td colspan="2"><textarea className="dagstaat_textarea" border="1">Geen technische gebreken
                    </textarea></td></tr>

                    <tr><td colspan="2">
                        indien u niet antwoord op deze dagstaat binnen 24u wordt deze automatisch als goedgekeurd beschouwd
                    </td></tr>
                </table>

                </div>

                {/* <div id="printcanvas" className="printcanvas">
                    <div key="headertabled0" id="headertabled" className="dagstaat_table" >
                        <img className="dagstaat_logo"></img>
                        <div className="dagstaat_title">{t('DAGSTAAT')}</div>
                        <div className="dagstaat_celborderL">{t('Naam Hotel')}</div><div className="dagstaat_celborderR">{hotel.Name}</div>
                        <div className="dagstaat_celborderL">{t('Datum')}</div><div className="dagstaat_celborderR">{moment(new Date(datum).toLocaleDateString('en-CA')).format("DD-MMM-YYYY")}</div>
                    </div>
                    <div className='dagstaat_groupbox'>
                         <label className='dagstaat_titleContentBox'>{t('Cleaningassignments')}</label>

                    {cleaningtypearray}
                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Extra betalende taken</div>
                    </div>
                    {payedtasksarray}
                    </div>
                    <div className='dagstaat_groupbox'>
                         <label className='dagstaat_titleContentBox'>{t('Algemene dienst')}</label>
                    {cleaningtypearrayAD}

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Extra betalende taken</div>
                    </div>

                    {generalservicespayedtasksarray}
</div>

                    {generalservicesextratimearray}

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Technische gebreken</div>
                        <div>
                            <textarea  className="dagstaat_textarea">Geen technische gebreken
                            </textarea></div>

                    </div>

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Opmerkingen</div>
                        <div style={dagstaten_commentsarray.length > 0 ? { display: 'none' } : { display: 'block' }}>
                            <textarea  className="dagstaat_textarea">Geen opmerkingen</textarea></div>
                        {dagstaten_commentsarray}
                    </div>

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow" >
                        <div className="dagstaat_celborderTopLine">&nbsp;</div><div className="dagstaat_celborderTopLine">&nbsp;</div>
                    </div>

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_3" >
                        indien u niet antwoord op deze dagstaat binnen 24u wordt deze automatisch als goedgekeurd beschouwd

                    </div>
                </div> */}
            </form>
        </>
    );
}


export default DagstaatNode;
